document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".custom-carousel");
  const pagination = document.querySelector(".slider__pagination");
  const leftButton = document.querySelector(".custom-carousel-button.left");
  const rightButton = document.querySelector(".custom-carousel-button.right");
  const collectionElements = document.querySelectorAll(".collection-info-seo");
  const collections = Array.from(collectionElements).map((element) => ({
    url: element.getAttribute("data-coll-url"),
    title: element.getAttribute("data-coll-title"),
  }));
  let currentIndex = 0;

  function calculateItemsPerSlide() {
    if (window.innerWidth >= 1920) return 12;
    if (window.innerWidth >= 1440) return 8;
    if (window.innerWidth >= 768) return 6;
    return 1;
  }

  function calculateItemsPerPagination() {
    return window.innerWidth >= 768 ? 1 : 2;
  }

  let itemsPerSlide = calculateItemsPerSlide();
  let itemsPerPagination = calculateItemsPerPagination();

  function populateCarousel() {
    carousel.innerHTML = "";
    const slides = [];
    for (let i = 0; i < collections.length; i += itemsPerSlide) {
      slides.push(collections.slice(i, i + itemsPerSlide));
    }

    slides.forEach((slideItems, index) => {
      const slide = document.createElement("div");
      slide.className = "carousel-cell-custom";
      const slideContent = document.createElement("div");
      slideContent.className = "linkboxes-teaser__slide";
      slideItems.forEach((collection) => {
        const item = document.createElement("a");
        item.href = collection.url;
        item.className = "btn btn-secondary";
        item.textContent = collection.title;
        slideContent.appendChild(item);
      });
      slide.appendChild(slideContent);
      carousel.appendChild(slide);
    });

    updatePagination(slides.length);
    updateButtons(slides.length);
  }

  function updatePagination(totalSlides) {
    pagination.innerHTML = "";
    const totalPaginationItems = Math.ceil(totalSlides / itemsPerPagination);
    for (let i = 0; i < totalPaginationItems; i++) {
      const paginationItem = document.createElement("span");
      paginationItem.className = "slider__pagination-item";
      if (i === Math.floor(currentIndex / itemsPerPagination))
        paginationItem.classList.add("slider__pagination-item--active");
      pagination.appendChild(paginationItem);
    }
  }

  function updateButtons(totalSlides) {
    leftButton.style.display = currentIndex === 0 ? "none" : "block";
    rightButton.style.display =
      currentIndex >= totalSlides - 1 ? "none" : "block";
  }

  function scrollToSlide(index) {
    const itemWidth = carousel.children[0].offsetWidth;
    const newPosition = index * itemWidth;
    carousel.scrollTo({ left: newPosition, behavior: "smooth" });
    currentIndex = index;
    updatePagination(Math.ceil(collections.length / itemsPerSlide));
    updateButtons(Math.ceil(collections.length / itemsPerSlide));
  }

  leftButton.addEventListener("click", () => {
    if (currentIndex > 0) {
      scrollToSlide(currentIndex - 1);
    }
  });

  rightButton.addEventListener("click", () => {
    const maxIndex = Math.ceil(collections.length / itemsPerSlide) - 1;
    if (currentIndex < maxIndex) {
      scrollToSlide(currentIndex + 1);
    }
  });

  window.addEventListener("resize", () => {
    itemsPerSlide = calculateItemsPerSlide();
    itemsPerPagination = calculateItemsPerPagination();
    currentIndex = 0;
    populateCarousel();
  });

  populateCarousel();
});
